"use strict";

var sortBy = require('lodash/sortBy');

var moment = require('moment');

var ShippingOption = require('./ShippingOption');

var traverseDecisionTree = require('../util/traverseDecisionTree');

function parseShippingOptions(order, options) {
  var order_date = moment(order.order_date).toISOString();
  var decisionTrees = sortBy(options.orders.getShippingServices, ['date']);
  var decisionTree;
  decisionTrees.forEach(function (_ref) {
    var date = _ref.date,
        tree = _ref.tree;

    if (order_date > moment(date).toISOString()) {
      decisionTree = tree;
    }
  });
  var options_key = traverseDecisionTree(order, decisionTree);
  var services = options.orders.services;

  if (!services[options_key]) {
    throw new Error("Did not find key ".concat(options_key, " in ShineShippingConfig.orders.services."));
  }

  return services[options_key];
}

module.exports = function getOrderShippingOptions(order, shipping_opts) {
  return parseShippingOptions(order, shipping_opts).map(function (opt) {
    return new ShippingOption(opt);
  });
};